import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import URL from '../../constants/urls'
import noop from 'lodash/noop'
import { useNavigate } from 'react-router-dom'
import ModalLogin from './modalLogin'
import { clearAllLoginLocalStorage, getPartnerDetails, isNotUrl, isPermissionExist, sortPortalPermissionByKey } from '../../utils/helper'
import whitepng from '../../assets/img/whitebg.png'
import CONSTANTS from '../../redux/constants'
import { getConfigDetails } from '../../services/config'
// import townsend from '../../assets/img/townsend.png'

function NavbarComponent(props) {
	// const { isAuthenticated, userData, permitData, waitListData, passData, paymentData } = props
	const { isAuthenticated, userData, waitListData, paymentData, setIsOpened, isOpened, notify, partnerDetails, setRouteDetecting, routeDetecting } = props
	// permissions section 
	const mean_menu_permission = partnerDetails?.customer_portal_permission


	// end of pemission section 
	const [isLoggedIn, setIsLoggedIn] = useState(false)
	const [userDetails, setuserDetails] = useState(false)
	const [partnerName, setPartnerName] = useState('')
	const [accessPermissions, setAccessPermissions] = useState(EMPTY_ARRAY)
	const [caller, setCaller] = useState()
	const [navbarShow, setNavbarShow] = useState(true)
	// const [isOpened, setIsOpened] = useState(false)
	const [show, setShow] = useState(false)
	// for modal open and close 

	// const [isLoginModal, setLoginModal] = useState(false)
	// 
	const { pathname } = useLocation()
	const navigate = useNavigate()
	const partner = window.location.toString().split('/')[3]
	// const facility = window.location.toString().split('/')[4]
	//let facility_shortName='PWCC'
	// if(localStorage.getItem('partnerData')!=undefined){
	// 	// const partnerData =localStorage.getItem('partnerData')? JSON.parse(localStorage.getItem('partnerData')):''
	// 	// facility_shortName=partnerData?.facilities[0]?.short_name
	// 	facility_shortName='PWCC'
	// }else{
	// 	facility_shortName='PWCC'
	// }
	const custDispatch = useDispatch()

	useEffect(() => {
		let nav = pathname.split('/')[1]
		if (nav == 'navigating') {
			setNavbarShow(false)
		} else {
			setNavbarShow(true)
		}
	}, [pathname])

	useEffect(() => {
		const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Access Permissions')
		setAccessPermissions(getAccessPermissionData)
	}, [EMPTY_ARRAY, partnerDetails])


	useEffect(() => {
		if (partner && partner != 'navigating' && isNotUrl(partner)) {
			setPartnerName(partner)
		} else if (getPartnerDetails()?.partner_slug) {
			setPartnerName(getPartnerDetails()?.partner_slug)
		}
	}, [EMPTY_ARRAY, partner])


	useEffect(() => {
		localStorage.setItem('isLoggedIn', false)
		const waitListDetails = waitListData?.userDetails
		// const permitDetails = permitData?.data
		// const userDetailsPass = passData?.data?.userDetails
		// const userDetailsPermit = permitDetails?.userDetails
		const userDetailsPayment = paymentData?.data?.userDetails
		if (isAuthenticated) {
			setIsLoggedIn(true)
			const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
			const userDetails = getuserDatafromLocal?.user
			if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token != '') {
				setuserDetails(userDetails)
			} else {
				const userDetails = userData?.data?.user
				setuserDetails(userDetails)
			}
		}
		else if (userDetailsPayment?.access_token && userDetailsPayment?.access_token != '') {
			setIsLoggedIn(true)
			localStorage.setItem('isLoggedIn', true)
			setuserDetails(userDetailsPayment?.user)
		}
		// else if (userDetailsPermit?.access_token && userDetailsPermit?.access_token != '') {
		// 	setIsLoggedIn(true)
		// 	localStorage.setItem('isLoggedIn', true)
		// 	setuserDetails(userDetailsPermit?.user)
		// } 
		else if (waitListDetails?.access_token && waitListDetails?.access_token != '') {
			setIsLoggedIn(true)
			localStorage.setItem('isLoggedIn', true)
			setuserDetails(waitListDetails?.user)
		}
		//  else if (userDetailsPass?.access_token && userDetailsPass?.access_token != '') {
		// 	setIsLoggedIn(true)
		// 	localStorage.setItem('isLoggedIn', true)
		// 	setuserDetails(userDetailsPass?.user)
		// }
		else {
			const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
			const userDetails = getuserDatafromLocal?.user
			if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token != '') {
				setuserDetails(userDetails)
				setIsLoggedIn(true)
				localStorage.setItem('isLoggedIn', true)
			} else {
				setIsLoggedIn(false)
			}
		}
		// }, [EMPTY_ARRAY, isAuthenticated, permitData, waitListData, passData,paymentData])
	}, [EMPTY_ARRAY, isAuthenticated, waitListData, paymentData, pathname])

	useEffect(() => {
		if (pathname.includes('user')) {
			setRouteDetecting(routeDetecting + 1)
		}
		window.scrollTo(0, 0)
	}, [pathname])

	const handleLogout = () => {
		let isResetScreen = window.location.href.includes('reset-password')
		clearAllLoginLocalStorage()
		setIsLoggedIn(false)
		if (isResetScreen) {
			navigate(0)
		} else {
			navigate(`${URL?.INDEX}/${partnerName}`)
			navigate(0)
		}
	}

	const handleModalOpen = () => {
		setShow(true)
		setCaller('nav')
		var navbarDiv = document.getElementById('mainNavID')
		navbarDiv?.classList?.remove('show')
	}

	const handleActiveTab = () => {
		setIsOpened(false)
		var navbarDiv = document.getElementById('mainNavID')
		navbarDiv?.classList?.remove('show')
	}

	const handleActivePermitTab = () => {
		setIsOpened(false)
		var navbarDiv = document.getElementById('mainNavID')
		navbarDiv?.classList?.remove('show')
		navigate(`${URL?.INDEX}/${partnerName}`)
		// navigate(0)
		custDispatch({type: CONSTANTS.PERMIT_PURCHAGE_CLICK})
	}
	const handleActivePermitRequestTab = () => {
		setIsOpened(false)
		var navbarDiv = document.getElementById('mainNavID')
		navbarDiv?.classList?.remove('show')
		navigate(`${URL?.INDEX}/${partnerName}/permit-request`)
		navigate(0)
	}
	const handleDropDown = (e) => {
		e.stopPropagation()
		if (isOpened) {
			setIsOpened(false)
		} else {
			setIsOpened(true)
		}
	}

	const handleLogoClick = () => {
		// const token = localStorage.getItem('token')
		// if (token && token != '') {
		// 	window.open(`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revtransientURL : getConfigDetails()?.transientURL}/${partner}`, '_self')
		// } else {
			navigate(`${URL?.INDEX}/${partnerName}`)
			navigate(0)
		// }

	}

	return (
		<header>
			<nav className="navbar navbar-expand-sm fixed-top navbar-light  shadow bg-white">
				<div className="container">
					<span className='navbar-bannd flex-grow-1 ' onClick={() => handleLogoClick()}>
						{/* <img height="50px" src="/assets/images/logo.png"></img> */}
						<img style={{ maxHeight: '40px' }} className='img-fluid' src={partnerDetails ? partnerDetails?.brand_setting ? partnerDetails?.brand_setting?.logourl : partnerDetails?.partner_details?.brand_setting?.logourl : getPartnerDetails()?.brand_setting ? getPartnerDetails()?.brand_setting?.logourl ? getPartnerDetails()?.brand_setting?.logourl : getPartnerDetails()?.parter_details?.brand_setting?.logourl : partner == 'townsend' ? whitepng : URL?.PARKENGAGE_LOGO_URL} alt={getPartnerDetails()?.name} />
					</span>
					{mean_menu_permission?.['Main Menu']?.length > 0 ?
						<button className="navbar-toggler border-0 px-1 mx-2 outline-none " type="button" data-bs-toggle="collapse" data-bs-target="#mainNavID" aria-controls="mainNavID" aria-expanded="false" aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button> : null}
						{navbarShow ? <>
							{isLoggedIn ?
							<div className="dropdown listStyleNone d-block d-sm-none " >
								{(isPermissionExist(accessPermissions, 'Account Access')) ? <i className='far fa-user-circle text-primary fa-lg' onClick={(e) => handleDropDown(e)}></i> : null}

								<ul className={isOpened ? 'dropdown-menu dropdown-menu-end d-block right-0' : 'dropdown-menu dropdown-menu-end right-0'}>
									{(isPermissionExist(accessPermissions, 'Account Access')) &&
										<>
											<li> <Link className={(pathname == `/${partnerName}${URL?.BASE_USER}`) ? 'nav-link activeLink ms-2' : 'nav-link ms-2'} to={`${partnerName}${URL?.BASE_USER}`} onClick={() => handleActiveTab()}>My Account</Link></li>
											<li> <hr className="dropdown-divider" /> </li>
										</>}
									{/* {(isPermissionExist(accessPermissions, 'Profile Access')) && <li>
										<Link className={(pathname == `/${partnerName}${URL?.BASE_USER_PROFILE}`) ? 'nav-link activeLink ms-2' : 'nav-link ms-2'} to={`${partnerName}${URL?.BASE_USER_PROFILE}`} onClick={() => handleActiveTab()}>Profile</Link>
									</li>}
									<li> <hr className="dropdown-divider" /></li> */}
									<li><button type='button' className="dropdown-item ms-2 ps-0" onClick={(e) => handleLogout(e)}>Logout</button></li>
								</ul>

							</div> : (isPermissionExist(accessPermissions, 'Login Access')) && <button className=" d-block d-sm-none btn btn-sm btn-primary">
								<i className="fa fa-sign-in " onClick={handleModalOpen} ></i>
							</button>}
						</> : ''}

					<div className="collapse navbar-collapse" id="mainNavID">
						<ul className="navbar-nav ms-auto">
							{mean_menu_permission?.['Main Menu']?.map((item, index) => {
								if (item?.display_name == 'Permit Purchase') {
									return <li className="nav-item" key={index}>
										{/* <Link className={((pathname == `${URL?.INDEX}/${partnerName}`) || (item?.web == `${URL?.INDEX}/${item?.web}/`)) ? 'nav-link px-3 mt-2 mt-sm-0 activeLink' : 'nav-link px-3 mt-2 mt-sm-0'} to={`${URL?.INDEX}/${partnerName}`} onClick={() => handleActiveTab()}>{item?.display_name}</Link> */}
										<Link className={((pathname == `${URL?.INDEX}/${partnerName}`) || (item?.web == `${URL?.INDEX}/${item?.web}/`)) ? 'nav-link px-3 mt-2 mt-sm-0 activeLink' : 'nav-link px-3 mt-2 mt-sm-0'} to={`${URL?.INDEX}/${partnerName}`} onClick={() => handleActivePermitTab()}>Permit Request</Link>

									</li>
								} else if (item?.display_name == 'Book Event') {
									const isMasquerade = localStorage.getItem('masquerade')
									let serverURL = window.location.host.includes('localhost') ? getConfigDetails()?.eventLocalUrl : item?.web
									let userData = JSON.parse(localStorage.getItem('userData'))
									let navigatingURL = `${serverURL}/${partnerName}`
									if (isMasquerade) {
										navigatingURL = `${serverURL}/navigating/${userData?.access_token}/${userData?.refresh_token}/${isMasquerade}/${partnerName}`
									} else if (isLoggedIn) {
										navigatingURL = `${serverURL}/navigating/${userData?.access_token}/${userData?.refresh_token}/${partnerName}`
									} else {
										navigatingURL = `${serverURL}/${partnerName}`
									}
									return <li className="nav-item" key={index}>
										<a className={'nav-link px-3 mt-2 mt-sm-0'} href={navigatingURL} rel="noreferrer" >{item?.display_name}</a>
									</li>
								} else if (item?.display_name == 'Permit Request') {
									return <li className="nav-item" key={index}>
										<Link className={'nav-link px-3 mt-2 mt-sm-0'} to={`/${partnerName}${item?.web}`} rel="noreferrer" onClick={() => handleActivePermitRequestTab()}>{item?.display_name}</Link>
									</li>
								} else {
									return <li className="nav-item" key={index}>
										<Link className={((pathname == `/${partnerName}${item?.web}`)) ? 'nav-link px-3 mt-2 mt-sm-0 activeLink' : 'nav-link px-3 mt-2 mt-sm-0'} to={`${partnerName}${item?.web}`} onClick={() => handleActiveTab()}>{item?.display_name}</Link>
									</li>
								}
							})}
							{isLoggedIn ?
								<li className=" nav-item dropdown  d-none d-sm-block" id="accountmenucontainer">
									{(isPermissionExist(accessPermissions, 'Account Access')) ? <span className='nav-link '>
										<Link className={(pathname == `/${partnerName}${URL?.BASE_USER}`) ? 'nav-link fw-bold ms-2 me-2 d-inline' : 'nav-link me-2 ms-2 d-inline'} to={`${partnerName}${URL?.BASE_USER}`} onClick={() => handleActiveTab()}>My Account</Link>
										<span className="dropdown-toggle fw-bold text-dark" href="javascript:;" role="button" onClick={(e) => handleDropDown(e)} ></span>
										{/* <a className="dropdown-toggle fw-bold text-dark" href="#" role="button" onClick={(e) => handleDropDown(e)} data-bs-toggle="dropdown" aria-expanded="false"></a> */}

									</span> : null}

									<ul className={isOpened ? 'dropdown-menu dropdown-menu-end d-block right-0' : 'dropdown-menu dropdown-menu-end right-0'}>
										{/* {(isPermissionExist(accessPermissions, 'Profile Access')) ? <li><Link className={(pathname == `/${partnerName}${URL?.BASE_USER_PROFILE}`) ? 'nav-link activeLink ms-2' : 'nav-link ms-2'} to={`${partnerName}${URL?.BASE_USER_PROFILE}`} onClick={() => handleActiveTab()}>Profile</Link></li> : null} */}
										{/* <li> <hr className="dropdown-divider" /></li> */}
										<li><button type='button' className="dropdown-item ps-4 ps-0" onClick={(e) => handleLogout(e)}>Logout</button></li>
									</ul>
								</li> : <li className=" nav-item d-none d-sm-block"><span className=' btn btn-primary  ' onClick={handleModalOpen}>
									<i className="showLoginIcon fa fa-sign-in text-primary" ></i>
									Login
								</span></li>}



							{/* {isLoggedIn ?
								<li className="nav-item dropdown d-none d-sm-block">
									
									<ul className={isOpened ? 'dropdown-menu dropdown-menu-end d-block right-0' : 'dropdown-menu dropdown-menu-end right-0'}>
										{(isPermissionExist(accessPermissions, 'Account Access')) &&
											<>
												<li> <Link className={(pathname == `/${partnerName}${URL?.BASE_USER}`) ? 'dropdown-item activeLink' : 'dropdown-item'} to={`${partnerName}${URL?.BASE_USER}`} onClick={() => handleActiveTab()}>My Account</Link></li>
												<li> <hr className="dropdown-divider" /> </li>
											</>}

										{(isPermissionExist(accessPermissions, 'Profile Access')) && <li>
											<Link className={(pathname == `/${partnerName}${URL?.BASE_USER_PROFILE}`) ? 'dropdown-item activeLink' : 'dropdown-item'} to={`${partnerName}${URL?.BASE_USER_PROFILE}`} onClick={() => handleActiveTab()}>Profile</Link>
										</li>}

										<li> <hr className="dropdown-divider" /></li>
										<li><button type='button' className="dropdown-item" onClick={(e) => handleLogout(e)}>Logout</button></li>
									</ul>
								</li> : (isPermissionExist(accessPermissions, 'Login Access')) && 
								<li className="nav-item d-none d-sm-block">
									<a className='nav-link' onClick={handleModalOpen}> 
										<i className="showLoginIcon fa fa-sign-in text-primary" ></i>
										<span className='showLoginText text-primary fw-bold cursor'>Login</span>
									</a>
								</li>} */}
						</ul>
					</div>
				</div>
			</nav>
			{partner ? <ModalLogin setShow={setShow} show={show} caller={caller} notify={notify} userDetails={userDetails} loginPermission={accessPermissions} partnerDetails={partnerDetails} /> : null}
			{/* <Login isLoginModal={isLoginModal} setLoginModal={setLoginModal} caller={caller} /> */}
		</header>
	)
}


NavbarComponent.propTypes = {
	dispatch: PropTypes.func,
	isAuthenticated: PropTypes.bool,
	userData: PropTypes.object,
	// permitData: EMPTY_OBJECT,
	// passData: EMPTY_OBJECT,
	paymentData: PropTypes.object,
	isModalOpen: PropTypes.bool,
	waitListData: PropTypes.object,
	setIsOpened: PropTypes.func,
	isOpened: PropTypes.bool,
	notify: PropTypes.func,
	setRouteDetecting: PropTypes.func,
	routeDetecting: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	partnerDetails: PropTypes.object,
}

NavbarComponent.defaulProps = {
	dispatch: noop,
	isAuthenticated: false,
	userData: EMPTY_OBJECT,
	// permitData: EMPTY_OBJECT,
	// passData: EMPTY_OBJECT,
	paymentData: EMPTY_OBJECT,
	isModalOpen: false,
	waitListData: EMPTY_OBJECT,
	setIsOpened: noop,
	isOpened: false,
	notify: noop,
	setRouteDetecting: noop,
	routeDetecting: '',
	partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ login, paymentReducer, basicInfoReducer, waitingListReducer }) {
	return {
		isAuthenticated: login?.isAuthenticated,
		userData: login?.data,
		// permitData: paymentReducer?.data,
		// passData: paymentReducer?.passData,
		paymentData: paymentReducer?.data,
		isModalOpen: basicInfoReducer?.isModalOpen,
		waitListData: waitingListReducer?.waitList?.data
	}
}
export default connect(mapStateToProps)(NavbarComponent)
